import script from "./TogglerOfWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./TogglerOfWrapper.vue?vue&type=script&setup=true&lang=js"

import "./TogglerOfWrapper.vue?vue&type=style&index=0&id=e1e1d9b2&lang=scss"

const __exports__ = script;

export default __exports__